import {
  KPI_ID_PARAM,
  KPI_LOCATION_PARAM,
  KPI_LOCATION_VALUES,
  KPI_MODAL_PARAM,
  KPI_MODAL_VALUES,
  type KPILocationValue,
} from './constants';

/**
 * Redirect to the given URL without triggering React Router,
 * otherwise it causes pages to 're-render' and that's not what we want
 */
const redirectToUrl = (url: string): void => {
  window.history.pushState({}, '', url);

  window.dispatchEvent(new PopStateEvent('popstate'));
};

/**
 * Open the create KPI modal with the given location
 */
export const openCreateKpiModal = (location: KPILocationValue) => {
  const url = new URL(window.location.href);

  url.searchParams.set(KPI_MODAL_PARAM, KPI_MODAL_VALUES.CREATE);
  url.searchParams.set(KPI_LOCATION_PARAM, location);

  redirectToUrl(url.toString());
};

/**
 * Open the view KPI modal with the given KPI ID and location
 */
export const openViewKpiModal = (kpiId: string, location: KPILocationValue) => {
  const url = new URL(window.location.href);

  url.searchParams.set(KPI_MODAL_PARAM, KPI_MODAL_VALUES.VIEW);
  url.searchParams.set(KPI_ID_PARAM, kpiId);
  url.searchParams.set(KPI_LOCATION_PARAM, location);

  redirectToUrl(url.toString());
};

/**
 * Map the KPI location to the event properties
 */
const mapEventProperties = (location: KPILocationValue | null) => {
  switch (location) {
    case KPI_LOCATION_VALUES.NAV_CREATE:
      return { location: 'NAVIGATION', subLocation: 'CREATE_BUTTON' };
    case KPI_LOCATION_VALUES.TEAM_PAGE_ADD:
      return { location: 'TEAM_PAGE', subLocation: 'ADD_BUTTON' };
    case KPI_LOCATION_VALUES.TEAM_PAGE_ROW:
      return { location: 'TEAM_PAGE', subLocation: 'TABLE_ROW' };
    case KPI_LOCATION_VALUES.TEAM_PAGE_TAB:
      return { location: 'TEAM_PAGE', subLocation: 'KPIS_TAB' };
    case KPI_LOCATION_VALUES.OKR_PAGE_ADD:
      return { location: 'OKR_PAGE', subLocation: 'ADD_BUTTON' };
    case KPI_LOCATION_VALUES.OKR_PAGE_ROW:
      return { location: 'OKR_PAGE', subLocation: 'TABLE_ROW' };
    case KPI_LOCATION_VALUES.OKR_PAGE_TRAY:
      return { location: 'OKR_PAGE', subLocation: 'KPIS_TRAY' };
    case KPI_LOCATION_VALUES.RBR_TRAY:
      return { location: 'BIZ_REVIEW', subLocation: 'KPIS_TRAY' };
    case KPI_LOCATION_VALUES.VIEW_KPI_UPDATE:
      return { location: 'VIEW_KPI', subLocation: 'UPDATE_BUTTON' };
    case KPI_LOCATION_VALUES.TOAST_CREATE_ANOTHER:
      return { location: 'NOTIFICATION', subLocation: 'CREATE_ANOTHER_BUTTON' };
    case KPI_LOCATION_VALUES.TOAST_VIEW_KPI:
      return { location: 'NOTIFICATION', subLocation: 'VIEW_KPI_BUTTON' };
    case KPI_LOCATION_VALUES.RELATIONSHIP_MAP:
      return { location: 'RELATIONSHIP_MAP', subLocation: 'GO_TO_BUTTON' };
    default:
      return { location: 'URL_PARAM' };
  }
};

/**
 * Get the shared data for the KPI applications
 */
export const getSharedData = (location: KPILocationValue) => ({
  currentUser: window.uData,
  analytics: {
    trackEvent: window.wb_track,
    eventProperties: mapEventProperties(location),
  },
});
